import { createTheme } from '@mui/material/styles';

// Couleurs Growlyy extraites du logo - version adoucie
const growlyy = {
  primary: {
    main: '#6D4C7D', // Violet encore plus adouci
    light: '#8E6D9E',
    dark: '#4D2C5D',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#E94979', // Rose/Fuchsia adouci
    light: '#FF6B99',
    dark: '#C92759',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#F9F7FC', // Fond légèrement teinté de violet très clair
    paper: '#FFFFFF',
  },
  text: {
    primary: '#3A3A3A',
    secondary: '#6E6E6E',
  },
  success: {
    main: '#4CAF50', // Vert pour les RDV pris
    light: '#81C784',
    dark: '#388E3C',
  },
  error: {
    main: '#F44336', // Rouge pour les refus
    light: '#E57373',
    dark: '#D32F2F',
  },
  linkedin: {
    main: '#0077B5', // Couleur LinkedIn
  }
};

// Création du thème personnalisé
const theme = createTheme({
  palette: {
    primary: growlyy.primary,
    secondary: growlyy.secondary,
    background: growlyy.background,
    text: growlyy.text,
    success: growlyy.success,
    error: growlyy.error,
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
      color: growlyy.primary.main,
    },
    h2: {
      fontWeight: 600,
      color: growlyy.primary.main,
    },
    h3: {
      fontWeight: 600,
      color: growlyy.primary.main,
    },
    h4: {
      fontWeight: 600,
      color: growlyy.primary.main,
    },
    h5: {
      fontWeight: 600,
      color: growlyy.primary.main,
    },
    h6: {
      fontWeight: 600,
      color: growlyy.primary.main,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: growlyy.primary.dark,
          },
        },
        containedSecondary: {
          '&:hover': {
            backgroundColor: growlyy.secondary.dark,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: growlyy.primary.main,
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: `linear-gradient(180deg, ${growlyy.primary.dark} 0%, ${growlyy.primary.main} 100%)`,
          color: '#FFFFFF',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            fontWeight: 600,
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-child td, &:last-child th': {
            border: 0,
          },
        },
      },
    },
  },
});

export default theme; 